<h5>Consulta de Protocolos</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
      <div class="bn-form-group botoes">
        <div class="float-end btnLimpar">
          <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
        </div>
        <div class="float-end btnPesquisar">
          <button #focusableSubmit type="button" [disabled]="!podePesquisar()" class="btn btn-success"
            (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)">Pesquisar</button>
        </div>
     </div>

     <h3>Filtros de pesquisa</h3>

    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="podeEscolherAgente" id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId"
          formControlName="agenteFinanceiro">
          <option [ngValue]="undefined" [selected]="true">Todos</option>
          <option *ngFor="let agente of agentesFinanceiros">{{ agente.nome }}</option>
        </select>
        <select *ngIf="!podeEscolherAgente" disabled id="agenteFinanceiro" class="form-select"
          [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <ng-container *ngFor="let agente of agentesFinanceiros">
            <option selected *ngIf="agente?.cnpj == cnpjUsuario">{{ agente.nome }}</option>
          </ng-container>
        </select>
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="statusProtocolo">Status da solicitação: </label>
        <select id="statusProtocolo" class="form-select" formControlName="statusProtocolo">
          <option [ngValue]="undefined" [selected]="true">Todos</option>
          <option value='S'>Sucesso</option>
          <option value='R'>Substituído</option>
        </select>
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="dataEnvioInicial">Data de envio inicial:</label>
        <bn-datepicker name="dataEnvioInicial" idInput="dataEnvioInicial" formControlName="dataEnvioInicial">
        </bn-datepicker>
      </div>
      <div class="bn-form-group col-md-2">
        <label class="form-label" for="dataEnvioFinal">Data de envio final:</label>
        <bn-datepicker name="dataEnvioFinal" idInput="dataEnvioFinal" formControlName="dataEnvioFinal">
        </bn-datepicker>
      </div>
    </div>
  </form>
</div>

<bn-loading-overlay></bn-loading-overlay>

<app-protocolo-renuncia-listagem *ngIf="pesquisado" [hidden]="esconderPesquisa" [cnpjAgente]="cnpjSelecionado" [protocolos]="protocolosRenuncia"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem" (aoMudarPagina)="mudancaPagina($event)"
  [exibirComboTipoArquivo]="exibirComboTipoArquivo" [formatoArquivo]="formatoArquivo"  (exportarProtocolosRenuncia)="exportarProtocolosRenuncia()" >
</app-protocolo-renuncia-listagem>


